import React, { useState } from "react";
import { Table, Tag, Button, Space, Avatar, Tooltip } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const ApplicationsPage = () => {
  const navigate = useNavigate();

  // Example static data (replace later with Firebase fetch)
  const [data] = useState([
    {
      key: "1",
      unit: "101",
      name: "Sarah M. Brooks",
      avatar: "https://i.pravatar.cc/40?img=1",
      date: "03/11/2025",
      amount: "$42,561",
      method: "Visa card **** 8263",
      agent: "Christa Sardina",
      property: "3822 DT Amersfoort",
      status: "New",
    },
    {
      key: "2",
      unit: "341",
      name: "Joe K. Hall",
      avatar: "https://i.pravatar.cc/40?img=2",
      date: "06/18/2023",
      amount: "$25,671",
      method: "PayPal",
      agent: "Darren Rivera",
      property: "3181 BE Rozenburg",
      status: "Lease Sent",
    },
    {
      key: "3",
      unit: "101",
      name: "Robert V. Leavitt",
      avatar: "https://i.pravatar.cc/40?img=3",
      date: "01/20/2025",
      amount: "$94,305",
      method: "Mastercard **** 9200",
      agent: "Robert V. Leavitt",
      property: "Julianastraat ZX 7031",
      status: "Rejected",
    },
    {
      key: "4",
      unit: "795",
      name: "Lydia Anderson",
      avatar: "https://i.pravatar.cc/40?img=4",
      date: "02/09/2025",
      amount: "$78,483",
      method: "Visa card **** 8940",
      agent: "Lydia Anderson",
      property: "2561 DB Den Haag",
      status: "Lease Sent",
    },
  ]);

  const statusColors = {
    New: "purple",
    "Lease Sent": "green",
    Rejected: "red",
  };

  const columns = [
    {
      title: "Unit",
      dataIndex: "unit",
      key: "unit",
      render: (unit) => (
        <a onClick={() => navigate(`/landlord/listings/${unit}`)}>{unit}</a>
      ),
    },
    {
      title: "Customer Photo & Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <Space>
          <Avatar src={record.avatar} />
          {text}
        </Space>
      ),
    },
    { title: "Date", dataIndex: "date", key: "date" },
    { title: "Amount", dataIndex: "amount", key: "amount" },
    { title: "Payment Method", dataIndex: "method", key: "method" },
    { title: "Agent Name", dataIndex: "agent", key: "agent" },
    { title: "Invested Property", dataIndex: "property", key: "property" },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => <Tag color={statusColors[status]}>{status}</Tag>,
    },
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Space>
          <Tooltip title="View Application">
            <Button
              shape="circle"
              icon={<EyeOutlined />}
              onClick={() => navigate(`/landlord/applications/${record.key}`)}
            />
          </Tooltip>
          <Tooltip title="Review/Send Lease">
            <Button shape="circle" icon={<EditOutlined />} />
          </Tooltip>
          <Tooltip title="Reject">
            <Button shape="circle" danger icon={<DeleteOutlined />} />
          </Tooltip>
        </Space>
      ),
    },
  ];

  return (
    <div style={{ padding: 24 }}>
      <Table columns={columns} dataSource={data} pagination={{ pageSize: 5 }} />
    </div>
  );
};

export default ApplicationsPage;
